import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45guard_45global from "/vercel/path0/middleware/auth-guard.global.ts";
import init_45sentry_45global from "/vercel/path0/middleware/init-sentry.global.ts";
import pre_45refresh_45global from "/vercel/path0/middleware/pre-refresh.global.ts";
import redirect_45global from "/vercel/path0/middleware/redirect.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45guard_45global,
  init_45sentry_45global,
  pre_45refresh_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.ts")
}